export const getVideoDuration = (file) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(video.src);

      if (isNaN(video.duration)) {
        reject("Invalid video duration");
      } else {
        resolve(Math.floor(video.duration)); // seconds
      }
    };

    video.onerror = () => reject("Failed to load video metadata");

    video.src = URL.createObjectURL(file);
  });
};
